import React from 'react';
import { Link } from 'react-router-dom';
import AuthSplitLayout from '../../../components/auth/AuthSplitLayout';

export default function ForgotPasswordPage() {
  const onSubmit: React.FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
  };

  return (
    <AuthSplitLayout
      title="Forgot your password?"
      subtitle="Enter your email and we’ll send you a reset link"
    >
      <form onSubmit={onSubmit} className="space-y-5">
        <div>
          <label className="block text-sm font-medium text-gray-700">Email</label>
          <input
            name="email"
            type="email"
            autoComplete="email"
            required
            className="mt-2 w-full rounded-lg border border-gray-300 px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-green-500"
            placeholder="name@company.com"
          />
        </div>

        <button
          type="submit"
          className="w-full rounded-lg bg-green-600 px-4 py-2.5 text-white font-semibold hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500"
        >
          Send reset link
        </button>

        <div className="text-sm text-gray-600">
          <Link to="/login" className="font-medium text-green-700 hover:text-green-800">
            Back to sign in
          </Link>
        </div>
      </form>
    </AuthSplitLayout>
  );
}
